import { render, staticRenderFns } from "./BottomSlider.vue?vue&type=template&id=2505094b&scoped=true"
import script from "./BottomSlider.vue?vue&type=script&lang=js"
export * from "./BottomSlider.vue?vue&type=script&lang=js"
import style0 from "./BottomSlider.vue?vue&type=style&index=0&id=2505094b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505094b",
  null
  
)

export default component.exports